import constants from "../../Utils/constants";
import useTranslator from "../../hooks/useTranslator";

export const isClientIdentificationPending = (tenant, ruleEnabled) =>
  ruleEnabled === true &&
  Boolean(tenant) &&
  tenant?.consents?.client_identification_consent?.status !==
    constants.ACCEPTED;

const ClientIdentificationStatus = () => {
  const { _t } = useTranslator();

  return (
    <span className="client-identification-status">
      {_t("amlSigningPending")}
    </span>
  );
};

export default ClientIdentificationStatus;
